export default [
  {
    name: "stocki_index",
    path: "/inv/stock",
    component: () => import("../pages/inv/stock/index.vue"),
  },
  {
    name: "stocki_log",
    path: "/inv/log-stock",
    component: () => import("../pages/inv/stockLog/index.vue"),
  },
  // {
  //   name: "stocki_in",
  //   path: "/inv/stock-in",
  //   component: () => import("../pages/inv/stockIn/index.vue"),
  // },
  {
    name: "stocki_out",
    path: "/inv/stock-out",
    component: () => import("../pages/inv/stockOut/index.vue"),
  },
  {
    name: "transferi_create",
    path: "/inv/transfer-stock",
    component: () => import("../pages/inv/transferStock/index.vue"),
  },
  // {
  //   name: "stocki_in",
  //   path: "/inv/add-product-code",
  //   component: () => import("../pages/inv/addCodeProduct/index.vue"),
  // },

  {
    name: "stockobts_index",
    path: "/inv/stock-obts",
    component: () => import("../pages/union/stock/index.vue"),
  },
  {
    name: "stockobts_log",
    path: "/inv/stock-obts/log",
    component: () => import("../pages/union/stock/logStock.vue"),
  },
  {
    name: "warehouse_index",
    path: "/inv/warehouse",
    component: () => import("../pages/global/warehouse/index.vue"),
  },
  {
    // Master gudang di koneksi DEFAULT (naturalfarm_dbdash) — tabel yang BERBEDA
    // dari /inv/warehouse di atas, yang mengelola salinan 4 baris di koneksi
    // `website`. Nama route satu kata sebelum underscore: group ACL diturunkan
    // lewat $route.name.split("_")[0], jadi `warehouse_union_index` akan
    // bertabrakan dengan halaman di atas.
    name: "warehouseunion_index",
    path: "/inv/warehouse-union",
    component: () => import("../pages/inv/warehouseUnion/index.vue"),
  },
  {
    name: "stockopname_index",
    path: "/inv/stockopname",
    component: () => import("../pages/inv/stockOpname/index.vue"),
  },
  {
    name: "stockopname_create",
    path: "/inv/stockopname/create",
    component: () => import("../pages/inv/stockOpname/create.vue"),
  },
  {
    // Manage (edit) — declared sebelum `:id` route supaya path /:id/manage
    // ke-match yang spesifik dulu, bukan jatuh ke detail route.
    name: "stockopname_manage",
    path: "/inv/stockopname/:id/manage",
    component: () => import("../pages/inv/stockOpname/manage.vue"),
  },
  {
    // Hak Akses Stock Opname (T2610-0044).
    //
    // ⚠️ DIDEKLARASIKAN SEBELUM `stockopname_detail`: route itu ber-path
    // `/inv/stockopname/:id`, jadi `/inv/stockopname/akses` akan ditelannya
    // sebagai id="akses" kalau urutannya dibalik — halaman detail terbuka untuk
    // kunjungan yang tidak ada, tanpa satu pun error yang menunjuk urutan route.
    // Alasan yang sama dengan `stockopname_manage` di atas.
    //
    // ⚠️ Nama route ber-prefix `stockopnameakses`, BUKAN `stockopname`:
    // sidebar.vue menurunkan group ACL lewat `$route.name.split("_")[0]`, dan
    // group terpisah di sinilah yang mencegah pemberian "Hak Akses" ikut
    // memberikan stockopname_create/update/showhide lewat cascade crud_child di
    // matriks IT. Lihat migrasi insert_stockopname_access_modules.
    name: "stockopnameakses_index",
    path: "/inv/stockopname/akses",
    component: () => import("../pages/inv/stockOpname/access/index.vue"),
  },
  {
    name: "stockopnameakses_manage",
    path: "/inv/stockopname/akses/atur",
    component: () => import("../pages/inv/stockOpname/access/manage.vue"),
  },
  {
    name: "stockopname_detail",
    path: "/inv/stockopname/:id",
    component: () => import("../pages/inv/stockOpname/detail.vue"),
  }
];
